import type { StyleDemand } from '../../gql';

import {
    randNumber,
    randUuid,
    randCurrencyCode,
    randBoolean,
    randWord,
} from '@ngneat/falso';

import { mockCustomerGroupDemand } from './mockCustomerGroupDemand';

/**
 * Will return a mocked StyleDemand object, useful for tests etc.
 * By default, creates a valid style demand based on determineFaultyStyleDemand validation rules:
 * - Always includes a priceStyleNumber (required for validity)
 * - If purchasePrice is set, currencyCode is also set
 */
const mockStyleDemand = (overwrite?: Partial<StyleDemand>): StyleDemand => {
    const hasPurchasePrice = randBoolean();

    const baseStyleDemand: StyleDemand = {
        buyerNumber: randBoolean() ? randUuid() : null,
        // If there's a purchase price, currency code must be set
        currencyCode: hasPurchasePrice ? randCurrencyCode() : null,
        customerGroupDemands: [
            mockCustomerGroupDemand(),
            mockCustomerGroupDemand(),
        ],
        isBomStyle: randBoolean(),
        // priceStyleNumber must always exist for validity
        priceStyleNumber: randNumber({ min: 10000000, max: 99999999 }),
        purchasePrice: hasPurchasePrice
            ? randNumber({ min: 10, max: 1000, fraction: 2 })
            : null,
        styleName: `${randWord({ capitalize: true })} ${randWord({ capitalize: true })}`,
        styleNumber: randNumber({ min: 10000000, max: 99999999 }),
        totalQuantity: randNumber({ min: 1000, max: 50000 }),
    };

    return { ...baseStyleDemand, ...overwrite };
};

export { mockStyleDemand };
